import React from 'react';
import { Redirect, Route } from 'react-router';
import { useSubscription } from '@meraki-internal/state';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { HeaderTabsState } from '../HeaderTabs';
import { AppointmentsPageRouteHandler } from '../appointments/AppointmentsPage';
import { JournalRouteHandler } from '../journal/JournalRouteHandler';
import { TasksPageRouteHandler } from '../tasks/TasksPage';

export const CalendarRouter: React.FC = () => {

    const tabsState = useInstance(HeaderTabsState);
    useSubscription(() => tabsState);

    return (
        <>
            <Route path="/calendar-redirect" exact render={() => {
                const lastTab = tabsState.getLastActiveTab('calendar-tabs');

                let redirectTo: string;
                if (lastTab?.dataId === 'journal-tab') {
                    redirectTo = `/calendar/journal`;
                } else if (lastTab?.dataId === 'tasks-tab') {
                    redirectTo = `/calendar/tasks`;
                } else {
                    redirectTo = `/calendar/appointments`;
                }

                return (
                    <Redirect to={redirectTo} />
                );
            }} />

            <AppointmentsPageRouteHandler />
            <TasksPageRouteHandler />
            <JournalRouteHandler />
        </>
    );
};
